import { useTranslation } from 'react-i18next';
import { ArrowSquareOutIcon } from '@phosphor-icons/react';
import type { UserCompanyGroupDto } from '@monorepo/shared';

interface DiffuseGroupOptionProps {
  group: UserCompanyGroupDto;
  isSelected: boolean;
  onToggle: (groupId: string) => void;
  onOpenGroup: (groupId: string) => void;
}

export const DiffuseGroupOption = ({
  group,
  isSelected,
  onToggle,
  onOpenGroup,
}: DiffuseGroupOptionProps) => {
  const { t } = useTranslation();

  return (
    <label className="flex items-center gap-3 p-3 border border-gray-200 rounded-lg cursor-pointer hover:bg-gray-50 transition">
      <input
        type="checkbox"
        checked={isSelected}
        onChange={() => onToggle(group.id)}
        className="w-5 h-5 text-primary border-gray-300 rounded focus:ring-2 focus:ring-primary"
      />
      <div className="flex-1">
        <div className="font-medium text-gray-900">{group.name}</div>
        <div className="text-sm text-gray-500">
          {t('documents.diffuse_modal.groups.members', { count: group.memberCount })}
        </div>
      </div>
      <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onOpenGroup(group.id);
        }}
        title={t('documents.diffuse_modal.groups.open_group')}
        aria-label={t('documents.diffuse_modal.groups.open_group')}
        className="flex-shrink-0 text-gray-400 hover:text-primary transition"
      >
        <ArrowSquareOutIcon size={24} />
      </button>
    </label>
  );
};
